export default "__VITE_ASSET__CLD$jAQp__"